import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { useUserStore } from '@/js/lib/store/user';
import { loading, info, confirm } from '@/js/lib/ui';
import { send, validateEmail } from '@/js/lib/api/mail-magazine';
import { EmailNotificationSettingId, setNotificationStatus } from '@/js/lib/api/account/your/setting/notification';
import IButton from '@/js/components/molecules/IButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'mailMagazine',
  setup(__props) {

const userStore = useUserStore();

const formData = ref({
  email: '',
});
const errorText = ref('');
const registMailmagazine = async () => {
  loading({
    asyncFunc: async () => {
      if (userStore.isAuthenticated) {
        await setNotificationStatus(EmailNotificationSettingId.SUBSCRIBE_NEWSLETTER, true);
      } else {
        try {
          const { error, message } = await send(formData.value.email);
          if (error) {
            info(message);
          } else {
            info('メールマガジンの登録を完了しました。\nありがとうございました。配信を楽しみにお待ち下さい。');
            formData.value.email = '';
            errorText.value = '';

            window.dataLayer?.push({
              event: 'subscribe',
              event_category: 'kpi',
              event_label: 'newsletter',
            });
          }
        } catch {
          info('メールマガジンの登録に失敗しました。\nお手数ですが初めからもう一度送信して下さい。');
        }
      }
    },
  });
};
const onSubmit = async () => {
  if (userStore.isAuthenticated) {
    registMailmagazine();
    return;
  }

  const validateResult = await validateEmail(formData.value.email);
  if (validateResult !== true) {
    errorText.value = validateResult;
    return;
  }

  if (await confirm('ご入力いただいたメールアドレスにメールマガジンをお送り致します。よろしいですか？')) {
    registMailmagazine();
  }
};

return { __sfc: true,userStore, formData, errorText, registMailmagazine, onSubmit, IButton }
}

})